import {
	FORM_REPORT_DELETE, FORM_REPORT_SUBMIT, FORM_REPORT_RESTORE, FORM_REPORT_WITHDRAW, FORM_REPORT_CREATE, FORM_REPORT_UPDATE
} from "routes.js";

export class ReportHelper {
	constructor(api, loadingService) {
		this.api = api;
		this.loadingService = loadingService;
	}

	submit(formId, report) {
		return this.api
			.put(FORM_REPORT_SUBMIT(formId, report.Id))
			.then((resp) => {
				return {
					...report,
					...resp,
					Rules: resp.Rules ?? []
				};
			});
	}

	withdraw(formId, report) {
		return this.api
			.put(FORM_REPORT_WITHDRAW(formId, report.Id))
			.then((resp) => {
				report = {
					...report,
					...resp,
					Rules: resp.Rules ?? []
				};

				delete report.Submitted;

				return report;
			});
	}

	delete(formId, report) {
		return this.api.put(FORM_REPORT_DELETE(formId, report.Id));
	}

	restore(formId, report) {
		return this.api
			.put(FORM_REPORT_RESTORE(formId, report.Id))
			.then((resp) => {
				report = {
					...report,
					...resp
				};

				return report;
			});
	}

	saveReport(formId, updates, report) {
		const isNewReport = (!report || !report.Id);

		const params = {
			Id: isNewReport ? undefined : report.Id,
			FormId: formId,
			Fields: updates
		};

		if(report?.Sequences !== undefined) {
			params.Sequences = report.Sequences;
		}

		const request = {
			action: isNewReport ? this.api.post : this.api.put,
			url: isNewReport ? FORM_REPORT_CREATE(formId) : FORM_REPORT_UPDATE(formId, report.Id)
		};

		return this.loadingService.watch(request.action(request.url, params));
	}
}

export default angular
	.module("vesl.services.report-helper", [])
	.service("reportHelper", ReportHelper).name;
